var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-end"},[_c('EmployeeGroupSchedulePurgeButton',{on:{"button-clicked":_vm.deleteSchedule}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }